import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-demo-seven',
  templateUrl: './demo-seven.component.html',
  styleUrls: ['./demo-seven.component.scss']
})
export class DemoSevenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
